import { createSlice } from '@reduxjs/toolkit';

// Helper function to decode JWT token and extract expiry
const decodeToken = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

const initialState = {
  refreshToken: null,
  accessTokenExpiry: null, // Track access token expiry instead
};

const superadminRefreshTokenSlice = createSlice({
  name: 'superadminRefreshToken',
  initialState,
  reducers: {
    restoreSuperadminRefreshToken: (state) => {
      // Restore from localStorage on app init
      const storedRefreshToken = localStorage.getItem('superadmin_refresh_token');
      const storedAccessTokenExpiry = localStorage.getItem('superadmin_access_token_expiry');
      
      if (storedRefreshToken) {
        state.refreshToken = storedRefreshToken;
      }
      
      if (storedAccessTokenExpiry) {
        state.accessTokenExpiry = parseInt(storedAccessTokenExpiry);
      }
    },
    setSuperadminRefreshToken: (state, action) => {
      const { refreshToken } = action.payload;
      state.refreshToken = refreshToken;
      
      // Persist refresh token to localStorage
      if (refreshToken) {
        localStorage.setItem('superadmin_refresh_token', refreshToken);
      }
    },
    setSuperadminAccessTokenExpiry: (state, action) => {
      const { accessToken } = action.payload;
      
      // Decode access token to extract expiry
      if (accessToken) {
        const decodedToken = decodeToken(accessToken);
        if (decodedToken && decodedToken.exp) {
          state.accessTokenExpiry = decodedToken.exp;
          
          // Persist access token expiry to localStorage
          localStorage.setItem('superadmin_access_token_expiry', decodedToken.exp.toString());
          
          // Calculate and log token validity
          const currentTime = Math.floor(Date.now() / 1000);
          const validityInSeconds = decodedToken.exp - currentTime;
          const validityInMinutes = Math.floor(validityInSeconds / 60);
          console.log(`[Superadmin Redux] Access token expiry set. Token valid for ${validityInMinutes} minutes`);
        }
      }
    },
    clearSuperadminRefreshToken: (state) => {
      state.refreshToken = null;
      state.accessTokenExpiry = null;
      
      // Clear from localStorage
      localStorage.removeItem('superadmin_refresh_token');
      localStorage.removeItem('superadmin_access_token_expiry');
    },
  },
});

export const { 
  restoreSuperadminRefreshToken, 
  setSuperadminRefreshToken, 
  setSuperadminAccessTokenExpiry, 
  clearSuperadminRefreshToken 
} = superadminRefreshTokenSlice.actions;

export default superadminRefreshTokenSlice.reducer;